import React, { useEffect } from "react";

import ClearIcon from "@material-ui/icons/Clear";
import ListIcon from "@material-ui/icons/List";

// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";

// custom components
import HashLoader from "react-spinners/HashLoader";

// styles
import "./styles.css";
import { css } from "@emotion/core";
import { MenuMini, styles } from "./styles";
import { useTimer } from "hooks/useTimer";

// actions creators

// variables

const useStyles = makeStyles(styles);

const override = css`
  display: block;
  margin: 2rem auto;
`;

const LateralCArd = ({
  isOpen,
  isLoading,
  colorRGB,
  color,
  onClose,
  children,
}) => {
  const classes = useStyles();
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  const [menuAnimaton, setMenuAnimation] = React.useState("cardHidden");
  const [runTimer] = useTimer(700);

  useEffect(() => {
    runTimer(setCardAnimation, ["cardOpen"]);
  }, []);

  const handleClose = () => {
    setCardAnimation("cardHidden");
    setMenuAnimation("cardOpen");
    if (onClose) {
      onClose();
    }
  };

  const handleMenu = () => {
    setCardAnimation("cardOpen");
    setMenuAnimation("cardHidden");
  };

  return (
    <React.Fragment>
      <Card
        login
        className={` ${classes[cardAnimaton]} ${classes.cardMapLeft}`}
      >
        <Button
          onClick={() => handleClose()}
          size="sm"
          justIcon
          className={classes.mapLateralCloseButtonRight}
          color={color}
          round
        >
          <ClearIcon />
        </Button>

        <CardBody className={classes.cardBody}>
          <HashLoader
            css={override}
            size={45}
            color={`${colorRGB}`}
            loading={isLoading}
          />
          {!isLoading && children}
        </CardBody>
      </Card>
      <MenuMini onClick={handleMenu} className={classes[menuAnimaton]}>
        <ListIcon className={classes.menuIcon} />
      </MenuMini>
    </React.Fragment>
  );
};

export default React.memo(LateralCArd);
